import React from 'react';

import Search from '../Search';
import Loader from '../Loader';
import { useSelector } from 'react-redux';
import InboxMessagesList from './InboxMessagesList';
import InboxAnnouncementsList from './InboxAnnouncementsList';
import './Inbox.scss';

const InboxItemsList = ({
  type,
  searchString,
  onSearch,
  onSelectItem,
  selectedId
}) => {
  const inboxLoader = useSelector(state => state.inbox?.inboxListLoader || false)  
  return (
    <div className='messagesList'>
      {inboxLoader && <Loader center={true} />}
      {(type === "Messages" || type === "Announcements") &&
      <div className='searchBox'>
        <Search
          value={searchString}
          placeholder={`Search ${type === "Messages" ? "Messages" : "Announcements"}...`}
          onChange={onSearch}
        />
      </div>}
      {(type === "Messages" || type === "General" || type === "Service Request") && 
        <InboxMessagesList 
          onSelectItem={onSelectItem} 
          selectedId={selectedId?.referenceId || ""}
          loader={inboxLoader}
        />}
      {type === "Announcements" && 
        <InboxAnnouncementsList 
          onSelectItem={onSelectItem} 
          selectedId={selectedId?.id || ""}
          loader={inboxLoader}
        />}
    </div>

  )
}

export default InboxItemsList;